/**
* 首页
* Created by dxw on 2020/03/17.
*/
<template>
  <div class="home-page">
    <div class="home-page-top">
      <div class="content">
        <!--<van-search
            v-model="searchName"
            shape="round"
            background="#4d8fff"
            placeholder="请输入您当前要搜索的商品"></van-search>-->
        <!--<div class="return" @click="goReturn">
          <van-icon name="arrow-left" color="#ffffff"/>
          返回
        </div>-->
        <div class="title center">首页</div>

        <div v-if="token" class="user-message">
          <span class="el-dropdown-link user-img">
            <img :src="user.headIconUrl" class="face" :alt="user.nickName">
          </span>

          <a href="#" @click="goLoginOut">退出</a>
        </div>
        <div class="right" v-if="!token">
          <div><a href="/login">登录</a></div>
          <div><a href="/register">注册</a></div>
        </div>
      </div>
    </div>


    <div class="home-page-banner">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in bannerList" :key="index">
          <img :src="item.advertisingPictureUrl" @click="goDetail(item.advertisingRedirectUrl)">
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="home-page-icon">
      <a class="icon" href="/mall">
        <img src="../../assets/images/shan.png">
        采销商城
      </a>
      <a class="icon" href="/article">
        <img src="../../assets/images/1.png">
        新闻中心
      </a>
      <a class="icon" href="/environmental">
        <img src="../../assets/images/2.png">
        将来学院
      </a>
      <a class="icon" href="/environmental/technical-library">
        <img src="../../assets/images/3.png">
        技术文库
      </a>
    </div>

    <div class="home-page-modular">
      <div class="modular1">
        <h1>个人中心</h1>
        <p>办公服务个人档案</p>
      </div>
      <div class="modular2" @click="goSign">
        <h1>每日签到</h1>
        <p>精品好礼等你来拿</p>
      </div>
    </div>
    <div class="home-page-mall">
      <img src="../../assets/images/8.png" @click="goMallV2">
    </div>


    <div class="home-page-advertisement">
      <img :src="mallAd.advertisingPictureUrl">

    </div>

    <div class="home-page-introduce">
      <div class="title">将来网介绍</div>
      <div class="content-word">
        将来网作为工业环保综合平台，团队从2016年起帆至今，致力于打通环保行业各项节点，将环保行业的制造商、经销商、工程企业及终端用户相互连接。
      </div>
      <div class="content-word">
        至今日，将来网精选了全国14大环保工业类产品线的可靠供应商，涵盖482类行业所需产品，并对入驻品牌及供应商进行严格审核，保证平台安心可靠。
      </div>
      <img src="../../assets/images/7.png">
    </div>
    <div class="home-page-library">
      <div class="title">
        <div class="test">将来学院</div>
        <a class="look-more" href="/environmental">查看更多 ></a>
      </div>

      <div class="library-content">

        <div class="left">
          <div class="banner-other">
            <div class="top">
              <!--              <el-carousel :interval="3000" arrow="never">-->
              <!--                <el-carousel-item v-for="(item,index) in recommendEnList" :key="index"-->
              <!--                                  @click.native="goThemDetails(item)"-->
              <!--                                  v-if="index<5">-->
              <!--                  <el-image style="width: 710px;height: 460px"-->
              <!--                            :src="item.targetCoverUrl"-->
              <!--                            fit="fit" @click="notGo" v-if="item.targetCoverUrl"></el-image>-->

              <!--                </el-carousel-item>-->
              <!--              </el-carousel>-->
              <van-swipe :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item,index) in recommendEnList" :key="index" @click.native="goThemDetails(item)"
                                v-if="index<5"><img :src="item.targetCoverUrl">
                </van-swipe-item>

              </van-swipe>
            </div>
            <div class="bottom">
              <div>
                <div class="tab-img-list">
                  <div v-for="(item,index) in brandList" :key="index" @click="chioceImg(item.id)" class="img-list"
                       v-if="index<4">
                    <el-image
                        style="width: 50px; height: 45px"
                        :src="item.brandLogoUrl"
                        fit="contain"></el-image>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="right">
          <div class="library-list" @click="goEnior">
            <img src="../../assets/images/xueyuan.jpg">
            <div class="arrow">将来学院</div>
          </div>
          <div class="library-list" @click="goLibrary">
            <img src="../../assets/images/wenku.jpg">
            <div class="arrow">技术文库</div>
          </div>
          <div class="library-list" @click="goTopic">
            <img src="../../assets/images/huati.jpg">
            <div class="arrow">话题区</div>
          </div>
        </div>

      </div>
    </div>
    <div class="home-page-news">
      <div class="title">
        <div class="test">新闻中心</div>
        <a class="look-more" href="/article">查看更多 ></a>
      </div>
      <div class="content">
        <!--        <div class="left-img">-->
        <!--          <el-carousel :interval="3000" arrow="never" indicator-position="outside">-->
        <!--            <el-carousel-item v-for="(item,index) in lunboList" :key="index" @click.native="goImpDetails(item.id)"-->
        <!--                              v-if="index<5">-->
        <!--              <el-image-->
        <!--                :src="item.newsCoverUrl"-->
        <!--                fit="cover" @click="notGo"></el-image>-->
        <!--              <div class="test">-->
        <!--                <div class="author-icon">-->
        <!--                  <img :src="item.reviewerAvatarUrl">-->
        <!--                  <div class="author-name">{{item.reviewerName}}</div>-->
        <!--                </div>-->
        <!--                &lt;!&ndash;                <div class="line"></div>&ndash;&gt;-->
        <!--                <div class="wordss">-->
        <!--                  <div class="wordss-title" :title="item.newsTitle">{{item.newsTitle}}</div>-->
        <!--                  <div :title="item.reviewContent">{{item.reviewContent}}</div>-->
        <!--                </div>-->
        <!--              </div>-->

        <!--            </el-carousel-item>-->
        <!--          </el-carousel>-->
        <!--        </div>-->
        <div class=right-tab>
          <div class="tab-list">
            <div v-for="(item,index) in tabList" class="tab-title" :key="index">
              <div :class="{'active':current==index}" @click="choices(index,item.id)">
                {{ item.newsCategoryName }}
              </div>

            </div>

          </div>
          <div class="tab-content">
            <div class="info" v-for="(item,index) in newsInfo" :key="index" v-if="index<3" @click="goDeatils(item.id)">
              <el-image
                  style="width: 129px; height: 77px"
                  :src="item.newsCoverUrl"
                  fit="cover"></el-image>

              <div class="right">
                <div class="article-title">
                  <div style="font-weight: 600;line-height: 20px" :title="item.newsTitle">{{ item.newsTitle }}
                    <div class="mark" v-if="item.isOriginal==1">原创</div>
                  </div>


                </div>
                <div style="color: #AFAEB4;font-size: 14px">{{ item.updateTime }}</div>
                <div class='article-test' :title="item.newsSummary">
                  {{ item.newsSummary }}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!--    <div class="home-page-mall" id="scoll3">-->

    <!--      <div class="title">-->
    <!--        <div class="line1"></div>-->
    <!--        <div class="test">MALL &nbsp;&nbsp;商城中心</div>-->
    <!--        <div class="line2"></div>-->
    <!--      </div>-->
    <!--      <div class="content">-->
    <!--        <div class="mall-introduce">-->
    <!--          <img src="../../assets/images/beij.png">-->
    <!--          <div class="mall-info">-->
    <!--            <div class="mall-name">将来网商城</div>-->
    <!--            <p>将来网作为环保行业综合平台，汇聚了行业采购、资料、技术以及各 项增值服务渠道，我们用心为行业伙伴提供全场景式服务并携手企业 完成数字化转型</p>-->
    <!--            <div class="btn"><a :href="receptionUrl">进入商城</a></div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash;      <div class="content">&ndash;&gt;-->
    <!--      &lt;!&ndash;        <div class="left">&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="top">产品中心</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <mall-menu></mall-menu>&ndash;&gt;-->

    <!--      &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;        <div class="right">&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="modular-title">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div>&ndash;&gt;-->
    <!--      &lt;!&ndash;              <div class="line"></div>&ndash;&gt;-->
    <!--      &lt;!&ndash;              <span>产品展示</span>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div>更多>></div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="modular-contain">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="product-list">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <img :src="img1">&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="product-list">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <img :src="img1">&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="product-list">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <img :src="img1">&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="product-list">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <img :src="img1">&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="product-list">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <img :src="img1">&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="product-list">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <img :src="img1">&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="product-list">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <img :src="img1">&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="product-list">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <img :src="img1">&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="product-list">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <img :src="img1">&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="product-list">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <img :src="img1">&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->


    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;      </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;      <div class="more">查看更多</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;      <div class="new-content">&ndash;&gt;-->
    <!--      &lt;!&ndash;        <div class="advertisement-tab">&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="advertisement-list" v-for="(item,index) in advertisementList" :key="index"&ndash;&gt;-->
    <!--      &lt;!&ndash;               :class="{'show':current1==index}" @click="choices1(index)">{{item}}&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;        <div class="advertisement-contain">&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="advertisement">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <el-image&ndash;&gt;-->
    <!--      &lt;!&ndash;              style="width: 220px; height: 180px"&ndash;&gt;-->
    <!--      &lt;!&ndash;              :src="img2"&ndash;&gt;-->
    <!--      &lt;!&ndash;              fit="cover"></el-image>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="name">&ndash;&gt;-->
    <!--      &lt;!&ndash;              格兰富 水泵&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="dialog">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <div>查看详情</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="advertisement">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <el-image&ndash;&gt;-->
    <!--      &lt;!&ndash;              style="width: 220px; height: 180px"&ndash;&gt;-->
    <!--      &lt;!&ndash;              :src="img2"&ndash;&gt;-->
    <!--      &lt;!&ndash;              fit="cover"></el-image>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="name">&ndash;&gt;-->
    <!--      &lt;!&ndash;              格兰富 水泵&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="dialog">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <div>查看详情</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="advertisement">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <el-image&ndash;&gt;-->
    <!--      &lt;!&ndash;              style="width: 220px; height: 180px"&ndash;&gt;-->
    <!--      &lt;!&ndash;              :src="img2"&ndash;&gt;-->
    <!--      &lt;!&ndash;              fit="cover"></el-image>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="name">&ndash;&gt;-->
    <!--      &lt;!&ndash;              格兰富 水泵&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="dialog">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <div>查看详情</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="advertisement">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <el-image&ndash;&gt;-->
    <!--      &lt;!&ndash;              style="width: 220px; height: 180px"&ndash;&gt;-->
    <!--      &lt;!&ndash;              :src="img2"&ndash;&gt;-->
    <!--      &lt;!&ndash;              fit="cover"></el-image>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="name">&ndash;&gt;-->
    <!--      &lt;!&ndash;              格兰富 水泵&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="dialog">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <div>查看详情</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="advertisement">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <el-image&ndash;&gt;-->
    <!--      &lt;!&ndash;              style="width: 220px; height: 180px"&ndash;&gt;-->
    <!--      &lt;!&ndash;              :src="img2"&ndash;&gt;-->
    <!--      &lt;!&ndash;              fit="cover"></el-image>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="name">&ndash;&gt;-->
    <!--      &lt;!&ndash;              格兰富 水泵&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="dialog">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <div>查看详情</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="advertisement">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <el-image&ndash;&gt;-->
    <!--      &lt;!&ndash;              style="width: 220px; height: 180px"&ndash;&gt;-->
    <!--      &lt;!&ndash;              :src="img2"&ndash;&gt;-->
    <!--      &lt;!&ndash;              fit="cover"></el-image>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="name">&ndash;&gt;-->
    <!--      &lt;!&ndash;              格兰富 水泵&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="dialog">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <div>查看详情</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="advertisement">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <el-image&ndash;&gt;-->
    <!--      &lt;!&ndash;              style="width: 220px; height: 180px"&ndash;&gt;-->
    <!--      &lt;!&ndash;              :src="img2"&ndash;&gt;-->
    <!--      &lt;!&ndash;              fit="cover"></el-image>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="name">&ndash;&gt;-->
    <!--      &lt;!&ndash;              格兰富 水泵&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="dialog">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <div>查看详情</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="advertisement">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <el-image&ndash;&gt;-->
    <!--      &lt;!&ndash;              style="width: 220px; height: 180px"&ndash;&gt;-->
    <!--      &lt;!&ndash;              :src="img2"&ndash;&gt;-->
    <!--      &lt;!&ndash;              fit="cover"></el-image>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="name">&ndash;&gt;-->
    <!--      &lt;!&ndash;              格兰富 水泵&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="dialog">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <div>查看详情</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="advertisement">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <el-image&ndash;&gt;-->
    <!--      &lt;!&ndash;              style="width: 220px; height: 180px"&ndash;&gt;-->
    <!--      &lt;!&ndash;              :src="img2"&ndash;&gt;-->
    <!--      &lt;!&ndash;              fit="cover"></el-image>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="name">&ndash;&gt;-->
    <!--      &lt;!&ndash;              格兰富 水泵&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="dialog">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <div>查看详情</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <div class="advertisement">&ndash;&gt;-->
    <!--      &lt;!&ndash;            <el-image&ndash;&gt;-->
    <!--      &lt;!&ndash;              style="width: 220px; height: 180px"&ndash;&gt;-->
    <!--      &lt;!&ndash;              :src="img2"&ndash;&gt;-->
    <!--      &lt;!&ndash;              fit="cover"></el-image>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="name">&ndash;&gt;-->
    <!--      &lt;!&ndash;              格兰富 水泵&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            <div class="dialog">&ndash;&gt;-->
    <!--      &lt;!&ndash;              <div>查看详情</div>&ndash;&gt;-->
    <!--      &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--      &lt;!&ndash;      </div>&ndash;&gt;-->
    <!--    </div>-->
    <!--    <div class="home-page-meeting">-->
    <!--      <div class="title">-->
    <!--        <div class="line"></div>-->
    <!--        <div class="test">EXHIBITION &nbsp;&nbsp;展会中心</div>-->
    <!--        <div class="line"></div>-->
    <!--      </div>-->
    <!--      <div class="more">查看更多</div>-->
    <!--      <div class="content">-->
    <!--        <div class="meeting-list">-->
    <!--          <img src="../../assets/images/555.png">-->
    <!--          <div class="meeting-word">-->
    <!--            <span>1111</span>-->
    <!--            <span>2222</span>-->
    <!--            <span>2020年2月-2020年3月</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="meeting-list">-->
    <!--          <img src="../../assets/images/667.png">-->
    <!--          <div class="meeting-word">-->
    <!--            <span>1111</span>-->
    <!--            <span>2222</span>-->
    <!--            <span>2020年2月-2020年3月</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="meeting-list">-->
    <!--          <img src="../../assets/images/756.png">-->
    <!--          <div class="meeting-word">-->
    <!--            <span>1111</span>-->
    <!--            <span>2222</span>-->
    <!--            <span>2020年2月-2020年3月</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="meeting-list">-->
    <!--          <img src="../../assets/images/888.png">-->
    <!--          <div class="meeting-word">-->
    <!--            <span>1111</span>-->
    <!--            <span>2222</span>-->
    <!--            <span>2020年2月-2020年3月</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div class="side-menu" v-if="scrollMenus==true">-->
    <!--      <div class="modular" @click="returnCom('scoll1')">-->
    <!--        <i class="iconfont">&#xe86f;</i>-->
    <!--        <span>新闻中心</span>-->
    <!--      </div>-->
    <!--      <div class="modular" @click="returnCom('scoll2')">-->
    <!--        <i class="iconfont">&#xe80a;</i>-->
    <!--        <span>将来学院</span>-->
    <!--      </div>-->
    <!--      <div class="modular" @click="returnCom('scoll3')">-->
    <!--        <i class="iconfont">&#xe8df;</i>-->
    <!--        <span>商城中心</span>-->
    <!--      </div>-->
    <!--      -->
    <!--    </div>-->

    <van-tabbar v-model="active" safe-area-inset-bottom placeholder>
      <van-tabbar-item>
        <span>首页</span>
        <img
            slot="icon"
            slot-scope="props"
            :src="props.active ? icon.active : icon.inactive"
        >
      </van-tabbar-item>
      <van-tabbar-item @click="goMallV2">
        <span>商城</span>
        <img
            slot="icon"
            slot-scope="props"
            src="../../assets/images/icon/15.png"
        ></van-tabbar-item>
      <van-tabbar-item @click="goArticle" class="office-automation-page">
        <i slot="icon"
           slot-scope="props"
           class="iconfont">
          &#xe784;
        </i>
        <span>OA</span>
        <!--<img
            slot="icon"
            slot-scope="props"
            src="../../assets/images/icon/17.png"
        >--></van-tabbar-item>
      <van-tabbar-item @click="goEnvironmental">
        <span>讲堂</span>
        <img
            slot="icon"
            slot-scope="props"
            src="../../assets/images/icon/19.png"
        ></van-tabbar-item>
      <van-tabbar-item @click="goCenter">
        <span>我的</span>
        <img
            slot="icon"
            slot-scope="props"
            src="../../assets/images/icon/12.png"
        ></van-tabbar-item>
    </van-tabbar>


  </div>
</template>

<script>
import img from '../../assets/images/huanbao.png'
import img1 from '../../assets/images/news.jpg'
import img2 from '../../assets/images/444.png'

import img13 from '../../assets/images/icon/13.png'
import img14 from '../../assets/images/icon/14.png'

import AppConfig from '../../appConfig'

export default {
  name: 'home-page',
  components: {},
  data() {
    return {
      active: 0,
      icon: {
        active: img14,
        inactive: img13
      },
      searchName: '',
      scrollMenus4: false,
      scrollMenus3: false,
      scrollMenus2: false,
      scrollMenus1: false,
      scrollMenus: false,
      img2: img2,
      img1: img1,
      imgUrl: [img1, img2, img1, img2, img1],
      current1: 0,
      current2: 0,
      current: 0,
      receptionUrl: AppConfig.API.RECEPTION_URL,
      enUrl: AppConfig.API.LOGIN_URL,
      workbenchLink: AppConfig.API.REDIRECT_URL,
      bannerList: [],
      lunboList: [],
      newsInfo: [],
      tabList: [],
      token: this.$store.state.token,
      user: this.$store.state.user,
      bigImg: '',
      num: 0,
      mallAd: [],
      recommendEnList: [],
      brandList: [],
      newsRank: [],
    }
  },
  methods: {
    //跳回首页
    goReturn(){
      this.$router.push('/')
    },
    goDetail(link) {
      window.location.href = link
    },

    //签到
    goSign() {
      console.log(this.token)
      if (this.token == null || this.token.length == 0) {
        this.$message.info('登录已失效,请登录')
        return false
      }

      this.$httpV3.post('user/points/sign/in')
          .then(res => {
            if (Number(res.data.code) === 10000) {
              this.getSignPoint()
            } else {
              this.$message.error(res.data.msg)
            }
          })
    },

    //获取签到积分
    getSignPoint() {
      this.$httpV3.post('user/info/current/points')
          .then(res => {
            if (Number(res.data.code) === 10000) {
              this.$toast.success('签到成功，连续签到' + res.data.data.continuousSignInCount + '天，今日积分' + res.data.data.todayIncomePoints)
            } else {
              this.$message.error(res.data.msg)
            }
          })
    },
    goCenter() {
      this.$router.push('/center')
    },
    goEnvironmental() {
      this.$router.push('/environmental')
      // window.location.href = this.enUrl + '/environmental'
    },
    goArticle() {
      this.$router.push('/office-automation')
    },
    goMallV2() {
      this.$router.push('/mall')
    },
    goThemDetails(item) {

      if (item.targetType == 20) {
        // this.$router.push('/environmental/environmental-protection/detail/' + item.id)
        window.location.href = this.enUrl + '/environmental/environmental-protection/detail/' + item.id
        // let routeUrl = this.$router.resolve('/environmental/environmental-protection/detail/' + item.id)
        // window.open(routeUrl.href, '_blank')
      } else {
        window.location.href = item.courseLinkUrl

      }

    },
    notGo() {
      document.body.style.overflow = 'auto'
    },
    goMall() {
      this.$router.go(0)
    },
    returnCom(name) {
      let id = '#' + name
      const returnEle = document.querySelector(id)
      if (!!returnEle) {
        returnEle.scrollIntoView()
      }
    },
    goTopic() {
      window.location.href = this.enUrl + '/environmental/topic'
      // let routeUrl = this.$router.resolve('/environmental/topic')
      // window.open(routeUrl.href, '_blank')
    },
    goLibrary() {
      window.location.href = this.enUrl + '/environmental/technical-library'
      // let routeUrl = this.$router.resolve('/environmental/technical-library')
      // window.open(routeUrl.href, '_blank')
    },
    goEnior() {
      window.location.href = this.enUrl + '/environmental'
      // let routeUrl = this.$router.resolve('/environmental')
      // window.open(routeUrl.href, '_blank')

    },
    prev() {

      this.num--
      if (this.num >= 0) {
        console.log(this.num)
        var a = document.getElementById('tabImgList')
        a.style.transform = 'translateX(' + -230 * this.num + 'px)'
        a.style.transition = 'all 0.2s'
        this.current2--
        this.bigImg = this.imgUrl[this.current2]
      } else {
        this.num++
        return false
      }
    },
    next() {
      var b = this.imgUrl.length - 3
      this.num++

      if (this.num <= b) {
        console.log(this.num)
        var a = document.getElementById('tabImgList')
        a.style.transform = 'translateX(' + -230 * this.num + 'px)'
        a.style.transition = 'all 0.2s'
        this.current2++
        this.bigImg = this.imgUrl[this.current2]
      } else {
        this.num--
        return false
      }

    },
    chioceImg(id) {
      this.$router.push('/environmental/business/' + id)
      //window.location.href = this.enUrl + '/environmental/business/' + id
      // document.body.style.overflow = 'auto'
      // let routeUrl = this.$router.resolve({path: '/environmental/business/' + id})
      // window.open(routeUrl.href, '_blank')
    },

    goLoginOut() {
      this.$httpV3.post('user/logoutService')
          .then(res => {
            console.log(res)
            if (Number(res.data.code) === 10000) {
              this.$store.commit('loginOut')
              this.delCookie('token')
              console.log(this.token)
              this.delCookie('userInfo')
              //清除用户缓存
              this.$message.success('退出成功')

              setTimeout('location.reload()', 500)
              // this.$router.push({path: 'login'})
            } else {
              this.$message.error({message: '操作失败，请刷新后再操作！'})
            }
          })
    },
    goImpDetails(id) {
      document.body.style.overflow = 'auto'
      let routeUrl = this.$router.resolve({path: '/article/details/' + id})
      window.open(routeUrl.href, '_blank')
    },
    goDeatils(id) {
      this.$router.push({path: '/article/details/' + id})

      // let routeUrl = this.$router.resolve({path: '/article/details/' + id})
      // window.open(routeUrl.href, '_blank')
    },

    choices(index, id) {
      if (id == -100) {
        this.current = index
        this.getNewsRank()
      } else {
        this.current = index
        this.getGoodNews(id)
      }

    },
    choices1(index) {
      this.current1 = index
    },
    //获取推荐新闻轮播
    getGoodNewsLunbo() {
      let obj = {
        size: '0'
      }
      this.$httpV3.post('website/news/list/special/column', obj).then(res => {
        if (Number(res.data.code) === 10000) {
          this.lunboList = res.data.data
        } else if (Number(res.data.code) === 20300) {
          this.$message.error(res.data.msg)
          this.$store.commit('loginOut')
          this.delCookie('token')
          this.delCookie('userInfo')
          this.$router.push('/login')
        }
      })
    },

    //查询新闻推荐分类
    getGoodNewsLabel() {
      let obj = {
        recommendCategory: 20,
        size: '0'
      }
      this.$httpV3.post('website/news/category/list/recommend', obj).then(res => {
        if (Number(res.data.code) === 10000) {
          this.tabList = res.data.data
          this.tabList.unshift({
            id: -100,
            bizNewsCategoryName: '',
            recommendCategory: '',
            newsCategoryName: '精彩推荐'
          })
          this.getNewsRank()
          // this.getGoodNews(this.tabList[1].id)
        }
      })
    },

    //查询推荐分类下的推荐新闻
    getGoodNews(id) {
      let obj = {
        newsCategoryId: id,
        newsRecommendCategory: 20,
        size: 0

      }
      this.$httpV3.post('website/news/list/recommend', obj).then(res => {
        if (Number(res.data.code) === 10000) {
          this.newsInfo = res.data.data
          for (let i = 0; i < this.newsInfo.length; i++) {
            this.newsInfo[i].updateTime = this.newsInfo[i].updateTime.timeStampFormat('yyyy-MM-dd')
          }
        }
      })
    },

    //获取首页广告位
    getMallBanner() {
      let obj = {
        platformAdvertisingCategory: 'SHUIWENSHE_HOME_PAGE_TOP_BANNER',
      }
      this.$httpV3.post('harbor/platform/advertising/list', obj).then(res => {
        if (Number(res.data.code) === 10000) {
          this.bannerList = res.data.data
          // for (let i = 0; i < this.bannerList.length; i++) {
          //   let num = this.bannerList[i].advertisingPictureUrl.indexOf('m')
          //   let str = this.bannerList[i].advertisingPictureUrl.substring(0, num)
          //   if (this.bannerList[i].advertisingPictureUrl.search('jianglaiwang') != -1) {
          //     this.bannerList[i].advertisingPictureUrl = this.bannerList[i].advertisingPictureUrl.replace(str, 'http://prod-jianglaiwang-1257889624.picsh.myqcloud.co') + '?imageMogr2/thumbnail/375x190!'
          //   } else {
          //     this.bannerList[i].advertisingPictureUrl = this.bannerList[i].advertisingPictureUrl.replace(str, 'http://test-jlwgroups-1257889624.picsh.myqcloud.co') + '?imageMogr2/thumbnail/375x190!'
          //
          //   }
          //
          // }

        }
      })
    },
    getMallAd() {
      let obj = {
        platformAdvertisingCategory: 'SHUIWENSHE_HOME_PAGE_MIDDLE_BANNER',
      }
      this.$httpV3.post('harbor/platform/advertising/list', obj).then(res => {
        if (Number(res.data.code) === 10000) {
          this.mallAd = res.data.data[0]
          // let num = this.mallAd.advertisingPictureUrl.indexOf('m')
          // let str = this.mallAd.advertisingPictureUrl.substring(0, num)
          // if (this.mallAd.advertisingPictureUrl.search('jianglaiwang') != -1) {
          //   this.mallAd.advertisingPictureUrl = this.mallAd.advertisingPictureUrl.replace(str, 'http://prod-jianglaiwang-1257889624.picsh.myqcloud.co') + '?imageMogr2/thumbnail/375x50!'
          // } else {
          //   this.mallAd.advertisingPictureUrl = this.mallAd.advertisingPictureUrl.replace(str, 'http://test-jlwgroups-1257889624.picsh.myqcloud.co') + '?imageMogr2/thumbnail/375x50!'
          //
          // }
        }
      })
    },

    getCompanyList() {
      let obj = {
        size: 5,

      }
      this.$httpV3.post('website/recommend/list/sws/page/home', obj).then(res => {
        if (Number(res.data.code) === 10000) {

          if (res.data.data) {
            if (res.data.data.length < 5) {
              this.recommendEnList = res.data.data
              //this.getCourseList()
            }

          } else {
            this.recommendEnList = res.data.data
          }
          console.log(this.recommendEnList)

        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    getCourseList() {
      let obj = {
        recommendType: 4010,

      }
      this.$httpV3.post('website/forum/course/list/frontend', obj).then(res => {
        if (Number(res.data.code) === 10000) {
          if (res.data.data.list) {
            for (let i = 0; i < res.data.data.list.length; i++) {
              this.recommendEnList.push({
                coverUrl: res.data.data.list[i].courseCoverUrl,
                courseLinkUrl: res.data.data.list[i].courseLinkUrl
              })

            }
            console.log(this.recommendEnList)
          }

        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    getBrandList() {
      let obj = {
        isCooperationCompany: 1,
        recommendType: 6010,
        pageSize: 0,
        pageIndex: 0,

      }
      this.$httpV3.post('website/brand/list', obj).then(res => {
        if (Number(res.data.code) === 10000) {
          this.brandList = res.data.data.list

        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    getNewsRank() {
      let obj = {
        size: 0
      }
      this.$httpV3.post('website/news/list/top', obj).then(res => {
        if (Number(res.data.code) === 10000) {

          this.newsInfo = res.data.data

          for (let i = 0; i < this.newsInfo.length; i++) {
            this.newsInfo[i].updateTime = this.newsInfo[i].updateTime.timeStampFormat('yyyy-MM-dd')
          }
        }
      })
    },

  },
  created() {

    // this.getSignPoint()
    this.getMallBanner()
    this.getMallAd()
    this.getGoodNewsLunbo()
    this.getGoodNewsLabel()
    this.getCompanyList()
    this.getBrandList()
    this.getNewsRank()
  },
  mounted() {

  }
}
</script>


<style lang="stylus" type="text/stylus">
.home-page
  width 100%
  height 100%
  background-color #f5f5f5
  .office-automation-page
    .iconfont
      font-size 22px
  .el-carousel__item.is-active
    z-index 1
  .home-page-top
    width 100%
    background-color #4d8fff
    color #ffffff
    font-size 14px

    .content
      margin 0 auto
      width 100%
      height 50px
      display flex
      justify-content flex-end
      align-items center
      text-align center
      .title
        &.center
          font-size 18px
          flex 1
          padding-left 0.75rem
      .return
        display flex
        align-items center
        font-size 18px
        .van-icon
          margin-right 5px
      .van-search
        width 73%
        .van-search__content
          border-radius 6px
          background-color #83b1ff
          .van-cell
            color #ffffff
            .van-field__control
              color #ffffff
            input:
            :-webkit-input-placeholder
              color #ffffff

            input:
            :-moz-placeholder
              color #ffffff

            input:-moz-placeholder
              color #ffffff

            input:-ms-input-placeholder
              color #ffffff

      .right
        div
          margin-right 10px
          cursor pointer
          display inline-block

          a
            color #ffffff

            &:hover
              color #466EF2

      .user-message
        display flex
        align-items center
        font-size 0
        position relative

        .user-img
          display inline-block
          overflow hidden
          border-radius 100%
          height 36px
          width 36px
          cursor pointer
          margin-right 5px

          img
            height 100%
            width 100%

        .name
          margin-right 5px
          display inline-block
          color #fff
          font-size 12px
          max-width 50px
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
          vertical-align top

        .grade
          margin-right 5px
          height 18px
          background #4a9bff
          color #fff
          padding 0 3px
          font-weight bold
          margin-left 5px
          font-size 12px

        a
          margin-right 5px
          display inline-block
          margin-left 5px
          color #fff
          font-size 12px

          &:hover
            color #0ab1fc

  .home-page-banner
    width 100%
    .van-swipe
      width 100%
      img
        width 100%

  .home-page-icon
    display flex
    width 100%
    padding 20px
    height 100px
    background-color #ffffff

    .icon

      margin 0 auto
      display flex
      flex-direction column
      justify-content center
      align-items center
      color #666666
      img
        margin-bottom 6px
        width 40px
        height 40px

  .home-page-modular
    background-color #ffffff
    margin-top 10px
    width 100%
    height 150px
    justify-content space-around
    display flex
    padding 20px
    color #ffffff
    .modular1
      margin-right 10px
      background url("../../assets/images/4.png") no-repeat center
    .modular2
      background url("../../assets/images/6.png")
    .modular1, .modular2
      display flex
      flex-direction column
      align-items center
      justify-content center
      background-size 100% 100%

      border-radius 8px
      width 320px
      text-align center
      h1
        margin-bottom 5px
        font-size 20px
    &::first-child
      margin-right 10px

  .home-page-news
    width 100%
    margin-top 10px
    padding: 20px 10px 60px 10px;
    background-color #fff

    .title
      margin 0 auto
      display flex
      align-items center
      justify-content space-between
      border-bottom 1px solid #f7f7f7
      margin-bottom 10px
      .test
        font-size 18px
        font-weight 600

        padding-bottom 5px
      .look-more
        color #939395

    .content
      width 100%
      margin 0 auto

      display flex

      .left-img
        width 400px
        height 360px
        margin-right 20px

        .el-carousel
          height 360px

          .el-carousel__container
            height 330px

            .el-carousel__item
              height 330px
              display flex
              align-items center
              justify-content center

              .el-image
                height 330px
                cursor pointer

              .test

                position absolute
                bottom 0
                left 0
                width 400px
                height 90px
                background-color: rgba(0, 0, 0, 0.5)
                color #ffffff
                cursor pointer
                padding 10px 25px
                display flex

                .author-icon
                  display flex
                  flex-direction column
                  align-items center
                  margin-right 20px

                  img
                    width 45px
                    height 45px
                    border-radius 50%

                  div
                    text-align center
                    overflow hidden
                    white-space nowrap
                    text-overflow ellipsis
                    font-size 14px

                .line
                  display inline-block
                  margin-right 25px
                  width 1px
                  height 50px
                  background-color #ffffff

                .wordss
                  padding-top 5px
                  border-left 1px solid #ffffff
                  padding-left 10px
                  height 59px
                  display inline-block
                  color #ffffff
                  font-size 14px
                  overflow hidden
                  text-overflow ellipsis

                  div
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size 15px
                    margin-bottom 5px

      .right-tab
        width 100%
        height 100%

        .tab-list
          display flex
          overflow: scroll;
          margin-bottom 5px

          .tab-title
            width 80px
            display flex
            justify-content center

            &:hover
              color #466EF4

            div

              text-align center
              width 97px
              cursor pointer

            .active
              border-bottom 1px solid #466ef4
              padding-bottom 5px
              color #466EF4

        .tab-content
          .info
            width 100%
            display flex
            padding 10px 0
            border-bottom 1px dashed #464B51
            cursor pointer

            .el-image
              width 129px
              height 77px
              margin-right 10px

            .right
              overflow hidden
              flex 1
              .article-title
                display flex
                justify-content space-between

                .mark
                  display inline-block
                  width 30px
                  border-radius 4px
                  line-height 19px
                  text-align center
                  height 20px
                  margin-left 10px
                  font-size 12px
                  color #347eff
                  border 1px solid #347eff

              .article-test
                font-size 14px
                color #666666
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

          div:last-child
            border none

  .home-page-advertisement
    width 100%
    img
      width 100%

  .home-page-introduce
    margin-top 10px
    background-color #ffffff
    padding 20px 10px
    .title
      font-size 18px
      font-weight 600
      border-bottom 1px solid #f7f7f7
      padding-bottom 5px
      margin-bottom 10px
    .content-word
      padding-left 5px
      margin-top 5px
      color #6f7176
      margin-bottom 5px
    img
      margin-top 10px
      width 100%

  .home-page-mall
    width 100%
    padding 10px
    img
      width 100%

  .home-page-meeting
    background-color #F9FAFF
    width 100%
    padding 70px 0

    .title
      width 1200px
      margin 0 auto
      display flex
      align-items center
      justify-content center
      margin-bottom 68px

      .line
        width 100px
        height 2px
        background-color #d4d4d5

      .test
        margin 0 40px
        font-size 22px
        font-weight 600

    .more
      display flex
      justify-content flex-end
      margin 0 auto
      width 1200px
      margin-bottom 10px
      cursor pointer
      color #3D5EF7

    .content
      width 1200px
      margin 0 auto
      display flex
      justify-content space-between

      .meeting-list
        width 276px
        border 1px solid #E2E2E2
        height 360px
        cursor pointer

        &:hover
          .meeting-word
            background linear-gradient(to top, #3959D0, #7F95E1)
            color #ffffff

          span:nth-child(2)
            color #ffffff

        img
          width 100%
          height 245px

        .meeting-word
          height 115px
          padding 20px 25px
          display flex
          font-size 14px
          flex-direction column

          span
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

        span:nth-child(2)
          color #3D5EF7

  .home-page-library
    width 100%
    margin-top 10px
    padding 20px 10px
    background-color #fff

    .title
      margin 0 auto
      display flex
      align-items center
      justify-content space-between
      border-bottom 1px solid #f7f7f7
      margin-bottom 10px
      .test
        font-size 18px
        font-weight 600

        padding-bottom 5px
      .look-more
        color #939395

    .library-content
      width 100%
      display flex
      justify-content center
      .img
        width 100%
        margin-top 20px

        img
          width 100%

      .right
        display flex
        flex-direction column

        .library-list:last-child
          margin-bottom 0

        .library-list
          cursor pointer
          width 100%
          height 60px
          font-size 14px
          position relative
          margin-bottom 10px

          img
            width 100%
            height 60px

          .arrow
            background-color: rgba(0, 0, 0, 0.5)
            position absolute
            bottom 0
            left 0
            width 100%
            color #ffffff
            text-align center
            line-height 18px
            height 18px

      .left
        margin-right 10px

        .banner-other
          width 100%
          height px
          display flex
          flex-direction column

          .top
            width 213px
            height 140px
            margin-bottom 10px

            .el-carousel
              cursor pointer
              width 213px
              height 140px

              .el-carousel__container
                width 213px
                height 140px

            img
              width 213px
              height 140px

          .bottom
            display flex
            height 45px

            .top-arrow
              width 15px
              height 100%
              text-align center
              margin-bottom 5px
              background-color #F1F1F1
              cursor pointer
              z-index 10

              .iconfont
                line-height: 170px;
                color #587FF8
                display: inline-block;
                transform: rotate(90deg);

            .tab-img-list
              width 100%
              height 45px
              display flex

              .img-list
                cursor pointer
                display inline-block
                height 45px
                box-sizing border-box
                width 50px

                margin-right 5px

                .el-image
                  overflow hidden

                  img
                    height 100%
                    width 100%
                    transition all 0.3s
                    display inline-block

                &:hover
                  box-shadow: 0 0 15px rgba(51, 51, 51, 0.3);

                  img
                    transform scale(1.1)

            .bottom-arrow
              z-index 10
              cursor pointer
              width 15px
              height 100%
              text-align center
              background-color #F1F1F1

              .iconfont

                line-height: 170px;
                color #587FF8

@media screen and (max-width: 900px)
  .home-page
    width 100%
    height 100%

</style>



// WEBPACK FOOTER //
// src/pages/home-page/index.vue